export interface IPaginatedSchema<T> {
    data: T[];
    meta: IMetaResponse;
}

export interface IMetaResponse {
    total: number;
    page: number;
    totalPages: number;
    limit: number;
}
